'use client';

import classNames from 'classnames';

import { ArticleCardColored } from '~components/ArticleCardColored/ArticleCardColored';
import { ScrollContainer } from '~components/ScrollContainer/ScrollContainer';
import { Section } from '~components/Section/Section';
import { HeaderSection } from '~containers/MainPage/HeaderSection/HeaderSection';
import { useBreakpoints } from '~hooks/useBreakpoints';

import styles from './Section4Cards.module.scss';
import { Section4CardsProps } from './Section4Cards.types';

const ARTICLES_COUNT = 4;

export function Section4Cards({
  title,
  titleBacklight,
  articles,
  category,
  ...sectionProps
}: Section4CardsProps) {
  const [, { isMobile }] = useBreakpoints();

  if (!articles.length) {
    return null;
  }

  const featuredArticles = articles.slice(0, ARTICLES_COUNT);

  return (
    <Section className={classNames(styles.section)} {...sectionProps}>
      {title && (
        <HeaderSection
          title={title}
          titleBacklight={titleBacklight}
          href={category.href}
          countArticles={category.count}
          hasPageCategory={!!category.href}
        />
      )}
      <ScrollContainer active={isMobile}>
        <div className={classNames(styles.articles)}>
          {featuredArticles.map((article) => (
            <ArticleCardColored
              key={article.id}
              className={styles.article}
              {...article}
              categories={[category]}
            />
          ))}
        </div>
      </ScrollContainer>
    </Section>
  );
}
